<template>
  <a-card :bordered="false">

    <div class="table-page-search-wrapper">
    </div>
    <div>
      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
        bordered
      >
        <Dict slot="allowDiferTime" slot-scope="text" :dict-code="DICT_CODE.ALLOW_DIFER_TIME" :value="text"/>
        <template slot="allowPrepay" slot-scope="text">
          {{text==0?'Not Allowed':'Allowed'}}
        </template>
        <span slot="action" slot-scope="text, record">
              <a @click="handleEdit(record)">Edit</a>
            </span>

      </a-table>
    </div>
  </a-card>
</template>

<script>
  import Dict from '../modules/Dict'
  import { riskFeaturesUsed } from '@/webpublicapi/risk'
  export default {
    name: 'productItemList',
    components: { Dict},
    props: {
      id:{
        type: [String, Number],
        default: undefined,
      }
    },
    data () {
      return {
        dataSource: [],
        loading: false,
        columns: [
          {
            title: 'StrategyID',
            align: 'center',
            dataIndex: 'id'
          },
          {
            title: 'Strategy Set ID',
            align: 'center',
            dataIndex: 'strategyId'
          },
          {
            title: 'Feature ID',
            align: 'center',
            dataIndex: 'featuresId'
          },
          {
            title: 'Execution Sequence',
            align: 'center',
            dataIndex: 'sortNum'
          },
          {
            title: 'Calculation Rule',
            align: 'center',
            dataIndex: 'rule'
          }
        ],
        title: 'Action',
        visible: false,
        screenWidth: 1200,
        model: {},
        proId: '',
      }
    },
    created () {
      this.proId = this.id;
      this.loadData()
    },
    methods: {
      loadData () {
        this.loading = true
        console.log(this.proId)

        riskFeaturesUsed(Object.assign({featuresId:this.proId})).then((res)=>{
          if(res.code===1000){
            this.dataSource = res.data
          }else{
            this.dataSource = []
            this.$message.error(res.msg)
          }
          this.loading = false
        }).catch(e => {
          this.loading = false;
          this.$message.error(e.message);
        })
      },


      handleAdd () {
        this.$refs.prodictItemModal.add(this.proId,this.appSsid)
        this.$refs.prodictItemModal.title = 'Add'
      },
      handleEdit (record) {
        record.allowDiferTime = record.allowDiferTime != undefined && '' + record.allowDiferTime;
        this.$refs.prodictItemModal.edit(record)
        this.$refs.prodictItemModal.title = 'Edit'
      },
      handleConfigAdd () {
        this.$refs.ProdictConfigModal.add(this.proId,this.appSsid)
        this.$refs.ProdictConfigModal.title = 'AddConfiguration'
      },
      // Edit dictionary data
      editProdictConfig () {
        this.$refs.ProdictConfigList.edit(this.proId,this.appSsid)
        this.$refs.ProdictConfigList.title = 'AddConfiguration'
      },
      modalFormOk () {
        this.loadData()
      }
    },
    watch: {
      proId (val) {
        this.proId = val
      }
    }
  }
</script>
<style scoped>

</style>
